"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantResponseDto = void 0;
/**
 * A tenant represents the account or workspace of a customer and encapsulate users for that workspace. A new tenant always creates an `OWNER` user that should be granted to change name, locale and manage the subscription (if using payment service).
 */
class TenantResponseDto {
}
exports.TenantResponseDto = TenantResponseDto;
